export const formatPrice = (price: string, addSymbol?: boolean): string => {
    let formattedPrice = Number.parseFloat(price).toFixed(2).replace('.', ',');

    if (addSymbol) {
        formattedPrice += ' €';
    }

    return formattedPrice;
};
